import ReporteBcraPage from "./ReporteBcraPage";

export {ReporteBcraPage}
export default ReporteBcraPage
